export default __webpack_public_path__ + "static/media/hht2_ep7_speaking_01.d49e890e.png";